import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { getDependentEntities } from '../modules/utils/services/dependentEntities';
export default function useInvalidateQueryKeys() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = function invalidateQueryKeys(path, t1) {
      const queryKeysToInvalidate = t1 === undefined ? [] : t1;
      const dependentEntities = [...getDependentEntities(path), ...queryKeysToInvalidate.flatMap(_temp)];
      new Set([path, ...queryKeysToInvalidate, ...dependentEntities]).forEach(queryKeyToInvalidate => {
        queryClient.invalidateQueries({
          queryKey: [queryKeyToInvalidate]
        });
      });
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(key) {
  return getDependentEntities(key);
}